export default {    
    Java: `
    import java.util.Scanner;
    public class sumOfMultiples {
        static int multiplesSum(int n, int m) {
            n = n-1; //has to be below the maximum number
            int x = (int) Math.floor(n/m); //taking only the integer
            int sum = (int) (m * x/2.0 * (x+1));
            return sum;
        }
            
        public static void main(String args[]) {
            Scanner myObj = new Scanner(System.in);
            System.out.println("Type the maximum number:");
            int n = myObj.nextInt();
            
            //The sum of multiples of 3 or 5 below n will be:
            int sum = (int) (multiplesSum(n, 3) + multiplesSum(n, 5) - multiplesSum(n, 15));
            System.out.println(sum);
        }
    }
`,
    JavaScript: `
    const multiplesSum = (n, m) =>{
        n = n-1 //has to be below the maximum number
        let x = Math.floor(n/m) //taking only the integer
        let sum = m * (x/2) * (x+1)
        return sum
      }

      //The sum of multiples of 3 or 5 below n will be:
      let sum = multiplesSum(n, 3) + multiplesSum(n, 5) - multiplesSum(n, 15)
      console.log(sum)
    `,
    Python: `
    import math
    def multipleSum(n, m):
        n = n - 1 #has to be below the maximum number
        x = math.floor(n/m) #taking only the integer
        sum = m * (x/2) * (x+1)
        return (sum)
    # The sum of multiples of 3 or 5 below n will be:
    sum = multipleSum(n, 3) + multipleSum(n, 5) - multipleSum(n, 15)
    print(sum)
    `
}

